import { AppConfig, PaymentStatus } from '@dh-io-emh/config-types';
import Order from '../models/order.model';
import { SMSOrder } from '@dh-io-emh/commerce-api/src/models/shared/ocb/api.schema';
import { createHttpService } from '../utils/http.util';

export type OrderApi = ReturnType<typeof createOrderApi>;

export const createOrderApi = ({ config: { apiBaseUrl, lang, siteId } }: { config: AppConfig }) => {
  const http = createHttpService({
    url: `${apiBaseUrl}/v2/${siteId}`,
    params: { lang },
  });

  return {
    async createOrder(userId: string, cartId: string, additionalUserAgreements: string[] = []): Promise<SMSOrder> {
      const url = `users/${userId}/orders`;
      const { data } = await http.post<SMSOrder>(url, {
        params: { fields: 'FULL' },
        data: { cartId, termsChecked: true, additionalUserAgreements },
      });

      return data;
    },

    async getOrder(userId: string, orderId: string) {
      const url = `users/${userId}/orders/${orderId}`;
      const { data } = await http.get<SMSOrder>(url, {
        params: {
          fields: 'FULL',
        },
      });

      return Order.create(data);
    },

    async checkPaymentStatus(userId: string, orderId: string) {
      const url = `users/${userId}/orders/${orderId}/payment/transaction-status`;
      const { data } = await http.get<{ status: PaymentStatus }>(url, {
        params: {
          fields: 'DCP',
        },
      });

      return data;
    },

    async initiatePayments(userId: string, order: unknown): Promise<unknown> {
      const url = `users/${userId}/orders/initiatepayments`;
      const { data } = await http.post(url, {
        params: { fields: 'DCP' },
        data: order,
      });

      return data;
    },
  };
};
